import { z } from 'zod'

export const datetimeLocal = z.string().datetime({ local: true })

export const stringToIntNumber = (value: string | null | undefined) => {
  if (value == null) return value // null or undefined
  const result = parseInt(value, 10)
  return Number.isInteger(result) ? result : null
}
